import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class CustomerForm {
  id: string;
  name?: string;
  email?: string;
  phone?: string;
  website?: string;
  address?: string;
  city?: string;
  district?: string;
  postalCode?: string;
  kepAddress?: string;
  taxOffice?: string;
  taxNumber?: string;
  mersisNumber?: string;
  paymentTerm?: string[];
  eInvoiceLiability?: string;
  contacts?: {
    department: string;
    contactName: string;
    contactEmail: string;
    contactPhone: string;
  }[];
  customerType?: string[];
  otherCustomerType?: string;
  averageDailyWeight?: number;
  averageDailyPiece?: number;
  hasIntegrationInfrastructure?: string;
  canPrintBarcodeInHouse?: string;
  descriptionForBarcode?: string;
  suitableVehicleType?: string[];
  isInsuranceCompensationRequired?: string;
  /** İstanbul çıkışlı firmalar — Avrupa Yakası uygun alım saatleri (opsiyonel, çoklu) */
  suitableTimeForEuropeSidePickup?: string[];
  /** İstanbul çıkışlı firmalar — Anadolu Yakası uygun alım saatleri (opsiyonel, çoklu) */
  suitableTimeForAnadoluSidePickup?: string[];
  /** İstanbul dışı firmalar — tek uygun alım saati 13:00–19:00 (opsiyonel; eski kayıtlarda yok) */
  pickupHourOutsideIstanbul?: string | null;
  sparePartShipmentFrequency?: string;
  createdAt: Date;
  updatedAt: Date;
}

export class ICustomerFormResponse {
  @Type(() => CustomerForm)
  result: CustomerForm;
}

export class ICustomerFormListResponse extends IPagination {
  @Type(() => CustomerForm)
  results: CustomerForm[];
}

export class ICustomerFormQueryDto extends IQueryPaginationDto {
  /** Genel arama: ad, e-posta, telefon, web, vergi no, MERSİS, şehir, ilçe, yetkili */
  search?: string;
  name?: string;
  email?: string;
  phone?: string;
  city?: string;
  district?: string;
  taxNumber?: string;
  taxOffice?: string;
  mersisNumber?: string;
  website?: string;
  /** Yetkili adı/e-postası/telefonu */
  contact?: string;
  customerType?: string;
  paymentTerm?: string;
  suitableVehicleType?: string;
  eInvoiceLiability?: string;
  hasIntegrationInfrastructure?: string;
  canPrintBarcodeInHouse?: string;
  isInsuranceCompensationRequired?: string;
  sparePartShipmentFrequency?: string;
  minDailyWeight?: number;
  maxDailyWeight?: number;
  minDailyPiece?: number;
  maxDailyPiece?: number;
  createdAtStart?: string;
  createdAtEnd?: string;
}
